// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/0cc16900/" + chunkId + "." + __webpack_require__.h() + ".v0cc16900.js";
};